export default [
  {
    path: '/login',
    name: '登录页',
    component: () => import('@/page/login/index'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/jumpPage',
    name: '跳转页',
    component: () => import('@/page/login/jumpPage'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/jumpPageSannuo',
    name: '跳转页',
    component: () => import('@/page/login/jumpPageSannuo'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/jumpPageH5',
    name: '大白主动健康',
    component: () => import('@/page/login/jumpPageH5'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/QRCode',
    name: '二维码页',
    component: () => import('@/page/login/QRCode'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/selectInstitution',
    name: '大白主动健康',
    component: () => import('@/page/login/selectInstitution'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/areaPage',
    name: '大白主动健康',
    component: () => import('@/page/login/areaPage'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/areaPageUserWebXL1',
    name: '大白星链Ⅰ',
    component: () => import('@/page/login/areaPageUserWebXL1'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/areaPageDoctorWeb',
    name: '大白医生端',
    component: () => import('@/page/login/areaPageDoctorWeb'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/privacyAgreement',
    // name: '大白隐私协议',
    name: '大白用户协议',
    component: () => import('@/page/login/privacyAgreement'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/privacyAgreementText',
    // name: '大白隐私协议文本版',
    name: '大白用户协议文本版',
    component: () => import('@/page/login/privacyAgreementText'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/privacyAgreementNew',
    name: '大白隐私协议最新',
    component: () => import('@/page/login/privacyAgreementNew'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/officialWebsite',
    name: '大白官网',
    component: () => import('@/page/login/officialWebsite'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/externalDynamicDataPage',
    name: '外部动态数据页面',
    component: () => import('@/page/login/externalDynamicDataPage'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/externalDynamicDetailPage',
    name: '外部动态数据详情页面',
    component: () => import('@/page/login/externalDynamicDetailPage'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/AIIntelligentAgent',
    name: '大白AI智能体',
    component: () => import('@/page/login/AIIntelligentAgent'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/S7vVAPcmbu.txt',
    name: '验证',
    component: () => import('@/page/login/S7vVAPcmbu.txt'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/jumpPage%E6%89%93%E5%BC%80%E6%9F%A5%E7%9C%8B',
    name: '跳转页',
    component: () => import('@/page/login/jumpPage'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/404',
    component: () => import('@/components/error-page/404'),
    name: '404',
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/403',
    component: () => import('@/components/error-page/403'),
    name: '403',
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/500',
    component: () => import('@/components/error-page/500'),
    name: '500',
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/mapShow',
    name: 'mapShow',
    component: () => import('@/views/customer/mapShow'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    },
    props: true// 允许通过 props 接收参数
  },
  // ,
  // {
  //   path: '*',
  //   redirect: '/404'
  // }
]
